import FileDownloadIcon from "@mui/icons-material/FileDownload";
import GenericExportButton from "components/GenericExportButton";
import { saveObjectToCsv } from "helpers/excelHelper";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  ListRequestOfUserFilter,
  UserFilter,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type ExportUsersProps = {
  sortField: string;
  sortDescending: boolean;
  userFilter: UserFilter;
};

const ExportUsers = ({
  sortField,
  sortDescending,
  userFilter,
}: ExportUsersProps) => {
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();
  const { organizationUserService } = useGlobalContext();

  const exportUsers = async (): Promise<void> => {
    const usersResponse = await organizationUserService.getUsers(
      ListRequestOfUserFilter.fromJS({
        pageSize: -1,
        sortField: sortField,
        sortDescending: sortDescending,
        parameters: userFilter,
      })
    );
    const usersToExport =
      usersResponse?.data?.map((user) => ({
        'Name': user.firstName,
        'Last Name': user.lastName,
        'Email': user.email,
        'Level of Access': user.accessLevelName,
        'Status': user.statusTypeName,
      })) ?? [];

    if (usersToExport.length) {
      saveObjectToCsv(organization!.name + " users", usersToExport);
    } else {
      return Promise.reject(new Error(t({ id: "unexpectedExportError" })));
    }
  };

  return (
    <GenericExportButton
      exportData={exportUsers}
      startIcon={<FileDownloadIcon />}
    />
  );
};

export default ExportUsers;
